// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { zkLinkNovaSepoliaTestnet as _zkLinkNovaSepoliaTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the zkLinkNovaSepoliaTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 810181
 * Chain Name: zkLink Nova Sepolia Testnet
 * Default Block Explorer: https://sepolia.explorer.zklink.io
 * Default RPC URL: https://sepolia.rpc.zklink.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { zkLinkNovaSepoliaTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: zkLinkNovaSepoliaTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const zkLinkNovaSepoliaTestnet = createCommon({
	..._zkLinkNovaSepoliaTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
